import { useFormikContext } from 'formik';
import React, {InputHTMLAttributes, ReactElement, useState} from 'react';
import { api } from '../services/api';

export interface FileFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label: string;
  isSubmitting?: boolean;
  sent?: boolean;
  mask?: (value: string) => string;
  parentName?: string;
  childName?: string;
  idx?: number;
}

export const FileField = ({ label, name, isSubmitting, sent, required = false, mask, parentName, childName, idx = -1, ...props }: FileFieldProps): ReactElement<HTMLDivElement> => {
  
  const { errors, touched, values, handleChange, handleBlur, setFieldValue } = useFormikContext<{ [name: string]: string }>();
  
  const [files, setFiles] = useState<any[]>();
  const [uploading, setUploading] = useState<boolean>(false);

  const handleUpload = async (file: File) => {
    setUploading(true);

    try {
      const formData = new FormData();
      formData.append('file', file);

      const { data: { filename } } = await api.post('/ficha-cadastral/upload', formData);
      
      // console.log('filename', filename);


      setFieldValue(name, filename);

    } catch (error) {
      console.log('error', error);
    }

    setUploading(false);

    console.log('file', file);
  }

  return (
    <div className='form-field'>
      
      <label htmlFor={`input-${name}`}>
        <span>{label}:{ required ? ' *' : '' }</span>
        <input
          type="text" 
          name={name}
          className="input-text" 
          id={`input-${name}`}
          placeholder={label}
          // value={files}
          // onChange={!mask ? handleChange : (v) => setFieldValue(name, mask(v.target.value))}
          onChange={(e) => {
            if (e.target.files && e.target.files.length === 1) {
              // setFiles(e.target.files)
              // setFile(e.target.files[0]);
              setFieldValue(name, '');
              handleUpload(e.target.files[0]);
            } else {
              setFieldValue(name, '');
            }
          }}
          onBlur={handleBlur}
          disabled={isSubmitting || sent || uploading}
          {...props}
        />
      </label>

      {uploading && (
        <div style={{color: 'blue'}}>Carregando arquivo, aguarde...</div>
      )}
      
      {!!errors?.[name] && !!touched?.[name] ? (
      <div className="form-error">{errors[name]}</div>
      ) : null}

      {!!parentName && !!childName && idx !== -1 && !!(errors as any)?.[parentName]?.[idx]?.[childName as any] && !!(touched as any)?.[parentName]?.[idx]?.[childName as any] && (
        <div className="form-error">{(errors as any)[parentName][idx][childName as any]}</div>
      )}
    </div>
  );
}